import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";

const ContactSection = () => {
  return (
    <div
      className="py-5"
      style={{
        background: "var(--bg-dark)",
        borderTop: "1px solid var(--glass-border)",
      }}
    >
      <div className="container text-center text-white">
        <h2
          className="display-5 fw-bold mb-5"
          style={{ color: "var(--text-main)", fontFamily: "var(--font-heading)" }}
        >
          Visit Our Classic Showroom
        </h2>
        <div className="row g-4 justify-content-center">
          <div className="col-12 col-md-4">
            <div className="d-flex align-items-center justify-content-center gap-3 p-3 glass-panel rounded-3" style={{ border: "1px solid var(--glass-border)" }}>
              <MapPin size={24} style={{ color: "var(--highlight-gold)" }} />
              <span className="fs-6" style={{ color: "var(--text-muted)" }}>
                456 Heritage Drive, Classic Hills, CA
              </span>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="d-flex align-items-center justify-content-center gap-3 p-3 glass-panel rounded-3" style={{ border: "1px solid var(--glass-border)" }}>
              <Phone size={24} style={{ color: "var(--highlight-gold)" }} />
              <span className="fs-6" style={{ color: "var(--text-muted)" }}>
                (555) 123-VINTAGE
              </span>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="d-flex align-items-center justify-content-center gap-3 p-3 glass-panel rounded-3" style={{ border: "1px solid var(--glass-border)" }}>
              <Mail size={24} style={{ color: "var(--highlight-gold)" }} />
              <span className="fs-6" style={{ color: "var(--text-muted)" }}>
                classics@vintagedealership.com
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
